import React from 'react';
import Drawer from '../../../BaseComponents/Drawers/Drawer/EDDrawer';
import EDTabs from '../../../BaseComponents/Tabs/EDTabs';
import EDTab from '../../../BaseComponents/Tabs/Tab/EDTab';
import Tasks from '../../Tasks/Tasks';
import Messages, { IMessage } from '../../Messages/Messages';
import EDIcon from '../../../BaseComponents/Icon/EDIcon';
import { Theme } from '@mui/material/styles';
import { withStyles } from 'tss-react/mui';
import EDOverlay from '../../../BaseComponents/Overlay/EDOverlay';
import EDAvatar from '../../../BaseComponents/Avatar/EDAvatar';
import EDTooltip from '../../../BaseComponents/Tooltip/EDTooltip';
import classNames from 'classnames';
import EDTypography from '../../../BaseComponents/Typography/EDTypography';
import { MessageUpdateType } from '../../Messages/Mutations/MessageListUpdateMutation';
import { MessageDeleteType } from '../../Messages/Mutations/MessageListDeleteMutation';

interface IProps {
  open: boolean;
  messages: IMessage[];
  updateMessage: MessageUpdateType;
  onToggle: () => void;
  deleteMessage: MessageDeleteType;
  onPinned: (pinned: boolean) => void;
  initialMessagesTab?: boolean;
  messagesLoading: boolean;
  classes?: any;
}

const styles = (theme: Theme) => ({
  wrapper: {
    display: 'inline-flex',
    flexDirection: 'row',
  },
  labelContainer: {
    paddingLeft: 8,
    paddingRight: 0,
    width: 'auto',
  },
  notificationOverlay: {
    bottom: -8,
    right: -8,
  },
  notificationIcon: {
    width: '20px',
    height: '20px',
    fontSize: theme.typography.pxToRem(12),
  },
  notificationIconHide: {
    opacity: 0,
  },
  avatarColor: {
    background: theme.customProperties.Warning.light,
    '&:hover': {
      background: theme.customProperties.Warning.main,
    },
  },
  simpleHeader: {
    width: '100%',
    padding: '24px 0px',
    marginBottom: 13,
    display: 'inline-flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'row',
  },
  messagePadding: {
    paddingLeft: 8,
  },
  iconMargin: {
    marginBottom: 6,
  },
});

interface IState {
  tabValue: number;
}

/**
 * Meny till höger som visar meddelanden och uppgifter(dessa visas för närvarande enbart i demoläge)
 */
export class TaskMenu extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);

    this.state = {
      tabValue: props.initialMessagesTab
        ? window.env.showDemoComponents
          ? 1
          : 0
        : 0,
    };
  }

  componentDidUpdate(prevProps: IProps) {
    if (prevProps.open !== this.props.open) {
      this.setState({
        tabValue: 0,
      });
    }
  }

  handleTabChange = (tab: number) => {
    this.setState({
      tabValue: tab,
    });
  };

  getHeaderContent = (): React.ReactNode => {
    const nrNotifications = this.props.messages.filter(
      message => !message.reciever.read
    ).length;
    const hide = nrNotifications === 0;
    const messagesOverlay = (
      <EDOverlay
        overlay={
          <EDTooltip
            title={hide ? '' : `${nrNotifications} olästa meddelanden`}
          >
            <EDAvatar
              className={classNames(this.props.classes.notificationIcon, {
                [this.props.classes.notificationIconHide]: hide,
              })}
              classes={{
                colorDefault: this.props.classes.avatarColor,
              }}
            >
              {nrNotifications}
            </EDAvatar>
          </EDTooltip>
        }
        classes={{
          overlay: this.props.classes.notificationOverlay,
          root: classNames({
            [this.props.classes.iconMargin]: !window.env.showDemoComponents,
          }),
        }}
      >
        <EDIcon color="inherit" iconType="assignment" />
      </EDOverlay>
    );

    if (!window.env.showDemoComponents) {
      return (
        <div className={this.props.classes.simpleHeader}>
          {messagesOverlay}
          <EDTypography
            className={this.props.classes.messagePadding}
            variant="button"
            color="inherit"
          >
            Meddelanden
          </EDTypography>
        </div>
      );
    }

    return (
      <React.Fragment>
        <EDTabs
          value={this.state.tabValue}
          onChange={this.handleTabChange}
          indicatorColor="white"
          variant="fullWidth"
        >
          {window.env.showDemoComponents && (
            <EDTab
              label="Uppgifter"
              icon={<EDIcon color="inherit" iconType="assignment" />}
              classes={{
                labelContainer: this.props.classes.labelContainer,
                // wrapper: this.props.classes.wrapper,
              }}
            />
          )}
          <EDTab
            label="Meddelanden"
            icon={messagesOverlay}
            classes={{
              labelContainer: this.props.classes.labelContainer,
              // wrapper: this.props.classes.wrapper,
            }}
          />
        </EDTabs>
      </React.Fragment>
    );
  };

  render() {
    return (
      <Drawer
        style={{ zIndex: 6000 }}
        open={this.props.open}
        type={'temporary'}
        anchor={'right'}
        header={{
          onToggle: this.props.onToggle,
          content: this.getHeaderContent(),
        }}
        toggleClosed={this.props.onToggle}
        onPinned={this.props.onPinned}
        pinnable
        noHeaderPadding
        testid="task-menu-drawer"
      >
        {this.state.tabValue === 0 && window.env.showDemoComponents && (
          <Tasks />
        )}
        {((this.state.tabValue === 1 && window.env.showDemoComponents) ||
          (this.state.tabValue === 0 && !window.env.showDemoComponents)) && (
          <Messages
            messages={this.props.messages}
            updateMessage={this.props.updateMessage}
            delete={this.props.deleteMessage}
            messagesLoading={this.props.messagesLoading}
          />
        )}
      </Drawer>
    );
  }
}

export default withStyles(TaskMenu, styles);
